/**
 * Polyfill for Promise.withResolvers which is not available in all environments.
 */
const withResolvers = () => {
    const out = {};
    out.promise = new Promise((resolve_, reject_) => {
        out.resolve = resolve_;
        out.reject = reject_;
    });
    return out;
};
export { withResolvers };
